import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteCategoria,
  getCategoriaById,
  postCategoria,
  updateCategoria,
} from "../../../../api/categoria";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Autocomplete } from "@material-ui/lab";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import { generateFriendlyUrl } from "../../../../utils/helpers";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export default function EditCategoriaPage() {
  const [categoria, setCategoria] = useState({
    active: true,
    nombre: "",
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const categoriaId = useParams().id;
  const classes = useStyles();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        if (categoriaId) {
          getCategoriaById(categoriaId)
            .then((resCategoria) => {
              if (resCategoria.status === 200) {
                setCategoria(resCategoria.data);
              }
            })
            .catch((error) => {
              setLoading(false);
              alertError({
                error,
                customMessage: "Could not get categoria details.",
              });
              history.push("/categorias");
            });
        }
      } catch (error) {
        setLoading(false);
        alertError({ error: error });
      }
    };

    fetchData();
    setLoading(false);
  }, [categoriaId, history]);

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!categoria[element]) categoria[element] = {};
      let newText = categoria[element];
      newText[lang] = event.target.value;

      // Si se está editando el título, actualizar automáticamente el enlace
      if (element === "name") {
        if (!categoria.enlace) categoria.enlace = {};
        categoria.enlace[lang] = generateFriendlyUrl(event.target.value);
      }

      setCategoria({ ...categoria, [element]: newText });
    } else setCategoria({ ...categoria, [element]: event.target.value });
  };

  const handleSave = () => {
    if (!categoriaId) {
      postCategoria(categoria)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Categoria saved successfully.",
          });
          history.push("/categorias");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save categoria details.",
          });
        });
    } else {
      updateCategoria(categoriaId, categoria)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Categoria saved successfully.",
          });
          history.push("/categorias");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save categoria details.",
          });
        });
    }
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <div className="row d-flex align-items-center">
        <div className="col-md-6">
          <TextField
            label="Nombre"
            value={categoria.name ? categoria.name[lang] : ""}
            onChange={handleChange("name", lang)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
        </div>
        <div className="col-md-6">
          <TextField
            label="Url amigable"
            value={categoria.enlace ? categoria.enlace[lang] : ""}
            onChange={handleChange("enlace", lang)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
        </div>
      </div>
    );
  };
  const renderContentDatosGenerales = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </>
    );
  };
  return (
    <>
      <Card>
        <CardHeader title="Edit Categoria" />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <CircularProgress className={classes.fancyLoader} />
          </div>
        ) : (
          <CardBody>
            {renderContentDatosGenerales()}
            <br />
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={categoria.active}
                  onChange={() =>
                    setCategoria({ ...categoria, active: !categoria.active })
                  }
                />
              }
              label="Active"
            />
          </CardBody>
        )}
      </Card>
      <Button
        onClick={() => history.push("/categorias")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>
      <Button
        onClick={handleSave}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save
      </Button>
      {categoriaId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this watch?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCategoria(categoriaId, categoria)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Delete successfully.",
                    });
                    history.push("/categorias");
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not save changes.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
